import { render, staticRenderFns } from "./DepartementEdit.vue?vue&type=template&id=47e998b4&"
import script from "./DepartementEdit.vue?vue&type=script&lang=js&"
export * from "./DepartementEdit.vue?vue&type=script&lang=js&"
import style0 from "./DepartementEdit.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports